import React from "react";
import "./StatusOfCompliance.scss";
import soc1 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 1.png";
import soc2 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 2.png";
import soc3 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 3.png";
import soc4 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 4.png";
import soc5 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 5.png";
import soc6 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 6.png";
import soc7 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 7.png";
import soc8 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 8.png";
import soc9 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 9.png";
import soc10 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 10.png";
import soc11 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 11.png";
import soc12 from "../../../assets/Reports/Status-of-compliance/Corporate Governance 12.png";

const StatusOfCompliance = () => {
  return (
    <>
      <div className="statusOfCompliance">
        <div className="container">
          <div className="heading_box">Status Of Compliance</div>
          <div className="my-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc1} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc2} className="img-fluid" alt="" />
              </div>

              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc3} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc4} className="img-fluid" alt="" />
              </div>

              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc5} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc6} className="img-fluid" alt="" />
              </div>

              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc7} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc8} className="img-fluid" alt="" />
              </div>

              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc9} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc10} className="img-fluid" alt="" />
              </div>

              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc11} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-5">
                <img src={soc12} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusOfCompliance;
